// extracted by mini-css-extract-plugin
export default {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","logo":"logo_logo__tzzBN","title":"logo_title__xv4la"};